module.exports = __webpack_public_path__ + "img/drop-drop-arrow.2beb3027.svg";